/**
 * 弹框表单样式
 */
import React, {Component} from "react";
import {Button, Form} from "antd";

export default class CmForm extends Component {
    render() {
        const {onSubmit} = this.props;
        return (
            <Form labelCol={{span: 4}} wrapperCol={{span: 17, offset: 1}}
                  onSubmit={(e)=>{ // 启动了表单的回车确认功能
                      e.stopPropagation();
                      e.preventDefault();
                      if(onSubmit && (typeof onSubmit==="function")) {
                          onSubmit(e);
                      }
                  }}
            >
                {this.props.children}
                {/*启动了表单的回车确认功能*/}
                {
                    onSubmit && (typeof onSubmit==="function") ? (
                        <Form.Item style={{display:"none"}}>
                            <Button type="primary" htmlType="submit">
                                确定
                            </Button>
                        </Form.Item>
                    ) : ""
                }
            </Form>
        );
    }
}